import React from 'react';
import { Button } from 'reactstrap';

const ButtonV2 = ({ children, className, style, size, ...props }) => {
  return (
    <Button
      className={`rounded-0 lh-1 ${className}`}
      style={{
        height: 'fit-content',
        padding: 6,
        fontSize: size === 'sm' ? 12 : 'inherit',
        borderRadius: '4px !important',
        ...style,
      }}
      size={size}
      {...props}
    >
      {children}
    </Button>
  );
};

export default ButtonV2;
